'use strict';

angular.module('far.gallery')
.controller('GalleryShowController', function(gallery) {
	var vm = {
		getGallery: getGallery,
		saveSort: saveSort
	};

	function getGallery(term, id) {
		vm.gallery = gallery(term, id);
	}

	function saveSort(index) {
		vm.gallery.splice(index, 1);
		vm.gallery.saveSort();
	}

	return vm;
});